import { Modal } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { ClassroomStudent } from '../types/classroom-student';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  student: ClassroomStudent | undefined;
};

function ConfirmDeleteStudentFromGroupModal({
  isOpen,
  isLoading,
  onDismiss,
  onConfirm,
  student,
}: Props): JSX.Element | null {
  const { t } = useTranslation();

  const handleCloseModal = (): void => {
    onDismiss();
  };

  if (!student) return null;

  return (
    <Modal
      title={t('students.delete-student-from-group.title')}
      isOpen={isOpen}
      onClose={onDismiss}
      buttons={[
        {
          children: t('common.accept'),
          onClick: onConfirm,
          loading: isLoading,
        },
        {
          children: t('common.cancel'),
          onClick: handleCloseModal,
          variant: 'tertiary' as const,
        },
      ]}
    >
      <>{t('students.delete-student-from-group.description')}</>
    </Modal>
  );
}

export { ConfirmDeleteStudentFromGroupModal };
